import {
  APISectorDetailKeyType,
  MapSetupItem,
  MapSetupItemKeyName,
  Sector,
  SectorDetailType,
} from '@/models/map'
import { mapSetupElements } from '@/utils/constants'

export function getSectorOnlineSetupItems(sector: Sector): MapSetupItem[] {
  const sectorDetails = sector.details.filter(
    (item) => item.type === SectorDetailType.ONLINE
  )

  if (sectorDetails.length === 0) {
    return []
  }

  const groupedData = sectorDetails.reduce<Record<string, MapSetupItem>>(
    (acc, item) => {
      acc[item.keyName] = {
        ...acc[item.keyName],
        icon: mapSetupElements[item.keyName as keyof typeof mapSetupElements][
          'icon'
        ],
        keyName: item.keyName as MapSetupItemKeyName,
        label: item.keyName,
        [item.keyType]: item.keyValue ?? 0,
        sectorId: item.sectorId,
      }

      return acc
    },
    {}
  )

  return Object.values(groupedData).filter(
    (item) => item.keyName !== MapSetupItemKeyName.COMBINED_LIMIT
  )
}

export function getVisibleStagingSetupItems(
  setupItems: MapSetupItem[]
): MapSetupItem[] {
  return setupItems.filter((item) => item[APISectorDetailKeyType.MAX] > 0)
}
